export const SORTS = {
  // SortByWidget.tsx
  WIDGET_CONTAINER: 'sort-by-widget-container',
  CONDITIONS_WRAPPER: 'sort-by-conditions-wrapper',
  CONDITION_WRAPPER: 'sort-by-condition-wrapper',
  SECOND_SORT_LABEL: 'sort-by-second-sort-label',
  ADD_CONDITION_BUTTON: 'sort-by-add-condition-button',
  ADD_CONDITION_ICON: 'sort-by-add-condition-icon',
  ADD_CONDITION_TEXT: 'sort-by-add-condition-text',
  DIALOG_ACTIONS: 'sort-by-dialog-actions',
  RESTORE_DEFAULT_BUTTON: 'sort-by-restore-default-button',

  // SortCondition.tsx
  CONDITION_CONTAINER: 'sort-condition-container',
  EMPTY_FIELD_WRAPPER: 'sort-condition-empty-field-wrapper',
  EMPTY_FIELD_BUTTON: 'sort-condition-empty-field-button',
  EMPTY_FIELD_TEXT: 'sort-condition-empty-field-text',
  EMPTY_FIELD_ARROW: 'sort-condition-empty-field-arrow',
  FIELD_WRAPPER: 'sort-condition-field-wrapper',
  FIELD_BUTTON: 'sort-condition-field-button',
  FIELD_ICON: 'sort-condition-field-icon',
  FIELD_LABEL: 'sort-condition-field-label',
  FIELD_ARROW: 'sort-condition-field-arrow',
  OPERATOR_WRAPPER: 'sort-condition-operator-wrapper',
  OPERATOR_BUTTON: 'sort-condition-operator-button',
  OPERATOR_LABEL: 'sort-condition-operator-label',
  OPERATOR_ARROW: 'sort-condition-operator-arrow',
  DELETE_BUTTON_WRAPPER: 'sort-condition-delete-button-wrapper',
  DELETE_BUTTON_ICON: 'sort-condition-delete-button-icon',
  TEMPORARY_SORT_POPUP: 'sort-condition-temporary-sort-popup',
  TEMPORARY_SORT_POPUP_WRAPPER: 'sort-condition-temporary-sort-popup-wrapper',
  TEMPORARY_SORT_POPUP_TITLE: 'sort-condition-temporary-sort-popup-title',
  TEMPORARY_SORT_POPUP_DESCRIPTION: 'sort-condition-temporary-sort-popup-description',
  TEMPORARY_SORT_POPUP_ACTIONS: 'sort-condition-temporary-sort-popup-actions',
  TEMPORARY_SORT_CANCEL_BUTTON: 'sort-condition-temporary-sort-cancel-button',
  TEMPORARY_SORT_REPLACE_BUTTON: 'sort-condition-temporary-sort-replace-button',

  // SortOrderDropDown.tsx
  ORDER_DROPDOWN_POPOVER: 'sort-order-dropdown-popover',
  ORDER_DROPDOWN_WRAPPER: 'sort-order-dropdown-wrapper',
  ORDER_DROPDOWN_ELEMENTS: 'sort-order-dropdown-elements',
  ORDER_DROPDOWN_SEARCH_WRAPPER: 'sort-order-dropdown-search-wrapper',
  ORDER_DROPDOWN_SEARCH_INPUT: 'sort-order-dropdown-search-input',
  ORDER_DROPDOWN_SEARCH_ICON: 'sort-order-dropdown-search-icon',
  ORDER_DROPDOWN_ITEM: 'sort-order-dropdown-item',
  ORDER_DROPDOWN_ITEM_LABEL: 'sort-order-dropdown-item-label',

  // SortFieldDropdown/Dropdown.tsx
  SORT_FIELD_DROPDOWN_POPOVER: 'sort-field-dropdown-popover',
  SORT_FIELD_DROPDOWN_SEARCH_WRAPPER: 'sort-field-dropdown-search-wrapper',
  SORT_FIELD_DROPDOWN_SEARCH_ICON: 'sort-field-dropdown-search-icon',
  SORT_FIELD_DROPDOWN_ELEMENTS: 'sort-field-dropdown-elements',
  SORT_FIELD_DROPDOWN_MENU_ITEM_ICON: 'sort-field-dropdown-menu-item-icon',
  SORT_FIELD_DROPDOWN_MENU_ITEM_LABEL: 'sort-field-dropdown-menu-item-label',
  SORT_FIELD_DROPDOWN_HELP_ICON: 'sort-field-dropdown-help-icon',
  SORT_FIELD_DROPDOWN_RIGHT_CHEVRON: 'sort-field-dropdown-right-chevron',
  SORT_FIELD_DROPDOWN_SEPARATOR: 'sort-field-dropdown-separator'
} as const;
